package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("GridAssessmentProcessStateEntry")
data class GridAssessmentProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: GridAssessmentProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry {

  override val availableOptions: List<GridAssessmentProcessStates>
    get() = GridAssessmentProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return processState.format(i18nConfiguration)
  }

  @Serializable
  @SerialName("GridAssessmentProcessStates")
  enum class GridAssessmentProcessStates : LizergyProcessStates {
    Missing,
    BeingEdited,
    WaitingForResponse,
    Rejected,
    Accepted,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        Missing -> ProcessStatePhase.Untouched
        BeingEdited -> ProcessStatePhase.InProgress
        WaitingForResponse -> ProcessStatePhase.Waiting
        Rejected -> ProcessStatePhase.Rejected
        Accepted -> ProcessStatePhase.Done
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        Missing -> "NVA fehlt"
        BeingEdited -> "NVA in Bearbeitung"
        WaitingForResponse -> "NVA gestellt"
        Rejected -> "NVA abgelehnt"
        Accepted -> "NVA freigegeben"
      }
    }
  }
}
